import { generateDialogParams } from '@/lib/generic.utils'
import { DataService, SubscriptionPeriodService } from '@/api'
import { get } from 'lodash'

const SERVICE = new SubscriptionPeriodService('subscription-periods')

export default {
  getAll(context) {
    return new Promise((resolve, reject) => {
      return SERVICE.get()
        .then(response => {
          context.commit('updateAll', response.data.result)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getSingle(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.get(params)
        .then(response => {
          context.commit('updateSingle', response.data.result)
          resolve(response.data.result)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deleteConfirmation(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.getDeleteConfirmation(params)
        .then(response => {
          context.commit(
            'updateGlobalDialogContent',
            generateDialogParams(params.dialogUid, 'deleteSingle', response.data),
            { root: true }
          )
          context.commit('updateGlobalDialogVisibility', { uid: params.dialogUid, value: true }, { root: true })
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deleteSingle(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.delete(params)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getCreateFormData(context) {
    return new Promise((resolve, reject) => {
      return SERVICE.getCreateFormData()
        .then(response => {
          context.commit('updateOwners', response.data.result.owners)
          context.commit('updateVendors', response.data.result.vendors)
          context.commit('updateProducts', response.data.result.products)
          context.commit('setTaskApplicability', response.data.result.task_applicability)
          context.commit('setMetaDataFields', response.data.result.meta_data_fields_by_category)
          context.commit('setFinancialPeriods', response.data.result.financial_periods)
          resolve()
        })
        .catch(err => reject(err))
    })
  },
  create(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.create(params)
        .then(response => {
          if (!get(response.data, 'result.errors')) {
            resolve(response.data.result)
          } else {
            reject(new Error('Error on submit'))
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  cancel(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.cancel(params)
        .then(response => {
          resolve(response.data.result)
        })
        .catch(error => reject(error))
    })
  },
  accept(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.accept(params)
        .then(response => {
          resolve(response.data.result)
        })
        .catch(error => reject(error))
    })
  },
  update(context, params) {
    return new Promise((resolve, reject) => {
      SERVICE.update(params, 'patch')
        .then(response => resolve(response.data.result))
        .catch(reject)
    })
  },
  createNewSubscriptionPeriod(context, params) {
    // this is used in top-bar actions
    return new Promise((resolve, reject) => {
      return SERVICE.createNewSubscriptionPeriod(params)
        .then(response => {
          context.dispatch('subscriptions/getSingle', { id: params.subscriptionId }, { root: true })
          resolve(response)
        })
        .catch(err => reject(err))
    })
  },
  getQuickviewData(context, params) {
    let SERVICE = new DataService(params.namespace)
    return new Promise((resolve, reject) => {
      return SERVICE.get().then(response => {
        if (!get(response.data, 'result.errors')) {
          resolve(response.data.result)
        } else {
          reject(response.data.message)
        }
      })
    })
  },
  processQuickviewData(context, params) {
    let SERVICE = new DataService(params.namespace)
    return new Promise(resolve => {
      return SERVICE.update(params).then(response => {
        resolve(response.data.result)
      })
    })
  },
  patch(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.patch(params)
        .then(() => resolve())
        .catch(err => reject(err))
    })
  },
  getMilestones(context, params) {
    const SERVICE = new DataService(`subscription-periods/${params.id}/milestone-meta-data`)

    return new Promise((resolve, reject) => {
      return SERVICE.get()
        .then(response => {
          context.commit('updateMilestonesMeta', response.data.result)
          resolve(response.data.result)
        })
        .catch(err => reject(err))
    })
  },
  getMilestone(context, params) {
    const SERVICE = new DataService(`subscription-periods/${params.entityId}/milestones/${params.milestoneId}`)

    return new Promise((resolve, reject) => {
      return SERVICE.get()
        .then(response => {
          context.commit('updateMilestones', {
            id: params.milestoneId,
            value: response.data.result
          })
          resolve(response.data.result)
        })
        .catch(err => reject(err))
    })
  }
}
